<div class="login-content">
  <section class="login-section">
    <mat-card class="login-card">
      <div class="login-card-header">
        <img src="assets/logo.png" alt="AllUnited Logo" class="card-logo" />
      </div>
      <mat-card-content>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Username</mat-label>
            <input matInput formControlName="username" type="text" autocomplete="username" placeholder="Enter your username">
            @if (loginForm.get('username')?.hasError('required') && loginForm.get('username')?.touched) {
              <mat-error>Username is required</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Password</mat-label>
            <input matInput formControlName="password" type="password" autocomplete="current-password" placeholder="Enter your password">
            @if (loginForm.get('password')?.hasError('required') && loginForm.get('password')?.touched) {
              <mat-error>Password is required</mat-error>
            }
          </mat-form-field>

          <button mat-raised-button color="primary" type="submit" class="full-width login-button" [disabled]="loading || !loginForm.valid">
            @if (loading) {
              <mat-spinner diameter="20" class="inline-spinner"></mat-spinner>
              <span>Signing in...</span>
            } @else {
              Sign In
            }
          </button>
        </form>
      </mat-card-content>
    </mat-card>
  </section>
</div>